import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Styles from "./style.module.scss";
import { useAppDispatch } from "../../redux/hooks";
import { handleOrderSuccessfullySent } from "../../redux/Reducers/orderSlice";
import { clearSessionRequestConfirmation, getSessionRequestConfirmation } from "../../utils/sessionRequestConfirmation";
import { Helmet } from "react-helmet-async";
import { handlerDeletePacketFromBasket } from "../../redux/Reducers/packetSlice";

export const OrderSuccess: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const confirmation = getSessionRequestConfirmation();

  useEffect(() => {
    dispatch(handlerDeletePacketFromBasket(null));
  }, [dispatch]);

  const handleBackHome = () => {
    dispatch(handleOrderSuccessfullySent(false));
    clearSessionRequestConfirmation();
    navigate("/");
  };

  return (
    <>
      <Helmet>
        <title>Session Request Sent | Alena Lobacheva Photography</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <section className={Styles.orderSuccess} aria-labelledby="session-request-success-title">
        <div className={Styles.orderSuccess__container}>
          <div className={Styles.orderSuccess__icon} aria-hidden="true">
            ✓
          </div>
          <p className={Styles.orderSuccess__eyebrow}>Request sent successfully</p>
          <h1 className={Styles.orderSuccess__title} id="session-request-success-title">
            Thank you for your session request
          </h1>
          <p className={Styles.orderSuccess__text}>
            Your request has reached Alena Lobacheva Photography. Alena will contact you shortly to confirm availability
            and discuss the session details.
          </p>

          <div className={Styles.orderSuccess__confirmation}>
            <strong>Confirmation email sent</strong>
            {confirmation?.email && <span>{confirmation.email}</span>}
            {confirmation?.orderNumber && <small>Request reference: {confirmation.orderNumber}</small>}
          </div>

          <div className={Styles.orderSuccess__nextStep}>
            <strong>No need to submit the form again.</strong>
            <span>If you would like to add anything, reply directly to the confirmation email.</span>
          </div>

          <button type="button" className={Styles.orderSuccess__button} onClick={handleBackHome}>
            Return to home
          </button>
        </div>
      </section>
    </>
  );
};

export default OrderSuccess;
